module.exports = __webpack_public_path__ + "img/message-question.2349ce01.svg";